import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

@Directive({
  selector: '[appTogglePassword]'
})
export class TogglePasswordDirective implements OnChanges {
  @Input({ required: true }) showPasswordLabel!: string;
  @Input({ required: true }) hidePasswordLabel!: string;

  private shown = false;
  private readonly shownClass = 'icon icon-invisible';
  private readonly hiddenClass = 'icon icon-visible';
  private readonly toggleButton: HTMLButtonElement;

  constructor(private el: ElementRef) {
    const parent = this.el.nativeElement.parentNode;
    const wrapper = document.createElement('div');
    const toggle = document.createElement('button');

    wrapper.className = 'password-lock-wrapper';
    toggle.type = 'button';
    toggle.className = this.hiddenClass;
    toggle.setAttribute('aria-pressed', 'false');
    toggle.addEventListener('click', () => {
      this.toggle(toggle);
    });
    wrapper.appendChild(this.el.nativeElement);
    wrapper.appendChild(toggle);
    parent.appendChild(wrapper);
    this.toggleButton = toggle;
  }

  ngOnChanges(): void {
    this.updateAccessibleLabel();
  }

  private toggle(toggle: HTMLButtonElement): void {
    this.shown = !this.shown;

    if (this.shown) {
      this.el.nativeElement.setAttribute('type', 'text');
      toggle.className = this.shownClass;
      toggle.setAttribute('aria-pressed', 'true');
    } else {
      this.el.nativeElement.setAttribute('type', 'password');
      toggle.className = this.hiddenClass;
      toggle.setAttribute('aria-pressed', 'false');
    }

    this.updateAccessibleLabel();
  }

  private updateAccessibleLabel(): void {
    this.toggleButton.setAttribute(
      'aria-label',
      this.shown ? this.hidePasswordLabel : this.showPasswordLabel
    );
  }
}
